import PropTypes from 'prop-types';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCircleInfo as icon } from '@fortawesome/free-solid-svg-icons';
import './Tooltip.css';

export const Tooltip = ({ children }) => {
    return(
        <div className='Tooltip'>
            <Icon icon={icon}/>
            <div className='Tooltip-text'>
                {children}
            </div>
        </div>
    );
};

Tooltip.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired,
};

export default Tooltip;
